export default "__VITE_ASSET__Dqu$7hdf__"